import { motion } from "framer-motion";
import { products } from "@/mock";

const fadeUp = {
  hidden: { opacity: 0, y: 30 },
  show: (i = 0) => ({
    opacity: 1,
    y: 0,
    transition: { duration: 0.7, ease: "easeOut", delay: i * 0.12 },
  }),
};

export const Products = () => {
  return (
    <section
      id="produkte"
      data-testid="products-section"
      className="relative bg-[#111111] py-24 lg:py-32"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <motion.div
          variants={fadeUp}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, amount: 0.3 }}
          className="max-w-2xl"
        >
          <p className="text-sm tracking-[0.2em] uppercase text-[#D4AF37] mb-4">
            Produkte Funebre
          </p>
          <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl text-[#F5F5F5] tracking-tight">
            Artikuj të përzgjedhur me kujdes
          </h2>
          <p className="mt-5 text-base text-gray-400 leading-relaxed">
            Nga dekorimet florale te arkivolët dhe monumentet, ofrojmë artikuj
            të kuruar me elegancë për të nderuar kujtimin e të dashurve tuaj.
          </p>
        </motion.div>

        <div className="mt-16 grid grid-cols-1 md:grid-cols-3 gap-8">
          {products.map((p, i) => {
            const Icon = p.icon;
            return (
              <motion.div
                key={p.id}
                data-testid={`product-card-${p.id}`}
                variants={fadeUp}
                custom={i}
                initial="hidden"
                whileInView="show"
                viewport={{ once: true, amount: 0.2 }}
                className="group bg-[#1A1A1A] border border-[#D4AF37]/20 rounded-2xl overflow-hidden hover:border-[#D4AF37]/60 transition-colors duration-500"
              >
                <div className="h-64 overflow-hidden">
                  <img
                    src={p.image}
                    alt={p.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
                  />
                </div>
                <div className="p-7">
                  <span className="inline-flex h-12 w-12 items-center justify-center rounded-full border border-[#D4AF37]/40 text-[#D4AF37] group-hover:bg-[#D4AF37] group-hover:text-black transition-colors duration-500">
                    <Icon size={22} strokeWidth={1.5} />
                  </span>
                  <h3 className="mt-5 font-serif text-2xl text-[#F5F5F5]">
                    {p.title}
                  </h3>
                  <p className="mt-2 text-sm text-gray-400 leading-relaxed">
                    {p.description}
                  </p>
                </div>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
